import * as React from 'react';
import { EdgeContainer } from './Container';
import { Map } from './Map';

interface Props {
  coords: [number, number];
}

export const MatchLocation: React.FunctionComponent<Props> = ({ coords }) => (
  <EdgeContainer>
    <Map coords={[coords]} className="h-72" />
  </EdgeContainer>
);
